(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-http.js', './ktor-ktor-shared-ktor-serialization.js', './ktor-ktor-io.js', './ktor-ktor-client-ktor-client-core.js', './ktor-ktor-utils.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-shared-ktor-serialization.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-client-ktor-client-core.js'), require('./ktor-ktor-utils.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-shared-ktor-serialization'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-shared-ktor-serialization' was not found. Please, check whether 'ktor-ktor-shared-ktor-serialization' is loaded prior to 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-client-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-client-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-ktor-client-core' is loaded prior to 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'.");
    }
    globalThis['ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'] = factory(typeof globalThis['ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'] === 'undefined' ? {} : globalThis['ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-shared-ktor-serialization'], globalThis['ktor-ktor-io'], globalThis['ktor-ktor-client-ktor-client-core'], globalThis['ktor-ktor-utils']);
  }
}(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.tc;
  var initMetadataForClass = kotlin_kotlin.$_$.qb;
  var plus = kotlin_kotlin.$_$.o8;
  var toMutableSet = kotlin_kotlin.$_$.r9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.p;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var register$default = kotlin_io_ktor_ktor_serialization.$_$.b;
  var Unit_instance = kotlin_kotlin.$_$.e5;
  var Configuration = kotlin_io_ktor_ktor_serialization.$_$.c;
  var VOID = kotlin_kotlin.$_$.i;
  var Exception = kotlin_kotlin.$_$.og;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.q1;
  var captureStack = kotlin_kotlin.$_$.za;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.h;
  var CoroutineImpl = kotlin_kotlin.$_$.qa;
  var THROW_CCE = kotlin_kotlin.$_$.wg;
  var TransformRequestBodyContext = kotlin_io_ktor_ktor_client_core.$_$.d;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.g;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.i;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.aa;
  var initMetadataForLambda = kotlin_kotlin.$_$.vb;
  var TransformResponseBodyContext = kotlin_io_ktor_ktor_client_core.$_$.e;
  var HttpResponse = kotlin_io_ktor_ktor_client_core.$_$.k;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.b1;
  var isInterface = kotlin_kotlin.$_$.gc;
  var contentType = kotlin_io_ktor_ktor_http.$_$.d1;
  var get_request = kotlin_io_ktor_ktor_client_core.$_$.m;
  var suitableCharset = kotlin_io_ktor_ktor_serialization.$_$.e;
  var toString = kotlin_kotlin.$_$.xc;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var accept = kotlin_io_ktor_ktor_client_core.$_$.h;
  var Collection = kotlin_kotlin.$_$.j5;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.q;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var contentType_0 = kotlin_io_ktor_ktor_http.$_$.b1;
  var EmptyContent_getInstance = kotlin_io_ktor_ktor_client_core.$_$.c;
  var Unit = kotlin_kotlin.$_$.ih;
  var charset = kotlin_io_ktor_ktor_http.$_$.z;
  var ensureNotNull = kotlin_kotlin.$_$.ph;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var equals = kotlin_kotlin.$_$.hb;
  var joinToString = kotlin_kotlin.$_$.r7;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.sb;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.d6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.o;
  var deserialize = kotlin_io_ktor_ktor_serialization.$_$.a;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.e;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.u4;
  var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.t;
  var getKClass = kotlin_kotlin.$_$.f;
  var setOf = kotlin_kotlin.$_$.a9;
  var createClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.f;
  var startsWith = kotlin_kotlin.$_$.cf;
  var endsWith = kotlin_kotlin.$_$.ee;
  var initMetadataForObject = kotlin_kotlin.$_$.wb;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.a1;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
  initMetadataForClass(ContentNegotiationConfig$defaultMatcher$1);
  initMetadataForClass(ContentNegotiationConfig, 'ContentNegotiationConfig', ContentNegotiationConfig, VOID, [Configuration]);
  initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
  initMetadataForLambda(ContentNegotiation$lambda$slambda, CoroutineImpl, VOID, [4]);
  initMetadataForLambda(ContentNegotiation$lambda$slambda_1, CoroutineImpl, VOID, [4]);
  initMetadataForCoroutine($invoke$convertRequestCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($invoke$convertResponseCOROUTINE$1, CoroutineImpl);
  initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
  //endregion
  function get_LOGGER() {
    _init_properties_ContentNegotiation_kt__o183go();
    return LOGGER;
  }
  var LOGGER;
  function get_DefaultCommonIgnoredTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return DefaultCommonIgnoredTypes;
  }
  var DefaultCommonIgnoredTypes;
  function get_ContentNegotiation() {
    _init_properties_ContentNegotiation_kt__o183go();
    return ContentNegotiation;
  }
  var ContentNegotiation;
  function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
    this.jcy_1 = converter;
    this.kcy_1 = contentTypeToSend;
    this.lcy_1 = contentTypeMatcher;
  }
  function defaultMatcher($this, pattern) {
    return new ContentNegotiationConfig$defaultMatcher$1(pattern);
  }
  function ContentNegotiationConfig$defaultMatcher$1($pattern) {
    this.mcy_1 = $pattern;
  }
  protoOf(ContentNegotiationConfig$defaultMatcher$1).ncy = function (contentType) {
    return contentType.n5c(this.mcy_1);
  };
  function ContentNegotiationConfig() {
    this.ocy_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.pcy_1 = ArrayList_init_$Create$();
  }
  protoOf(ContentNegotiationConfig).jbs = function (contentType, converter, configuration) {
    var matcher = contentType.equals(Application_getInstance().f5b_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
    this.qcy(contentType, converter, matcher, configuration);
  };
  protoOf(ContentNegotiationConfig).qcy = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    configuration(converter);
    var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
    this.pcy_1.e(registration);
  };
  function ContentConverterException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, ContentConverterException);
  }
  function ContentNegotiationConfig$_init_$ref_1ne3ob() {
    var l = function () {
      return new ContentNegotiationConfig();
    };
    l.callableName = '<init>';
    return l;
  }
  function ContentNegotiation$lambda($this$createClientPlugin) {
    _init_properties_ContentNegotiation_kt__o183go();
    var registrations = $this$createClientPlugin.zc4_1.pcy_1;
    var ignoredTypes = $this$createClientPlugin.zc4_1.ocy_1;
    $this$createClientPlugin.sck(ContentNegotiation$lambda$slambda_0(registrations, ignoredTypes, $this$createClientPlugin, null));
    $this$createClientPlugin.ecf(ContentNegotiation$lambda$slambda_2(ignoredTypes, registrations, $this$createClientPlugin, null));
    return Unit_instance;
  }
  function invoke$convertRequest(registrations, ignoredTypes, $this_createClientPlugin, request, body, $completion) {
    var tmp = new $invoke$convertRequestCOROUTINE$0(registrations, ignoredTypes, $this_createClientPlugin, request, body, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function invoke$convertResponse(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion) {
    charset = charset === VOID ? Charsets_getInstance().u53_1 : charset;
    var tmp = new $invoke$convertResponseCOROUTINE$1(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function ContentNegotiation$lambda$slambda($registrations, $ignoredTypes, $this_createClientPlugin, resultContinuation) {
    this.kd0_1 = $registrations;
    this.ld0_1 = $ignoredTypes;
    this.md0_1 = $this_createClientPlugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$lambda$slambda).rd0 = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
    var tmp = this.sd0($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(ContentNegotiation$lambda$slambda).jcg = function (p1, p2, p3, p4, $completion) {
    var tmp = p1 instanceof TransformRequestBodyContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
    var tmp_1 = !(p3 == null) ? p3 : THROW_CCE();
    return this.rd0(tmp, tmp_0, tmp_1, (p4 == null ? true : p4 instanceof TypeInfo) ? p4 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$lambda$slambda).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 2;
            this.g9_1 = 1;
            suspendResult = invoke$convertRequest(this.kd0_1, this.ld0_1, this.md0_1, this.od0_1, this.pd0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 2) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$lambda$slambda).sd0 = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, completion) {
    var i = new ContentNegotiation$lambda$slambda(this.kd0_1, this.ld0_1, this.md0_1, completion);
    i.nd0_1 = $this$transformRequestBody;
    i.od0_1 = request;
    i.pd0_1 = body;
    i.qd0_1 = _unused_var__etf5q3;
    return i;
  };
  function ContentNegotiation$lambda$slambda_0($registrations, $ignoredTypes, $this_createClientPlugin, resultContinuation) {
    var i = new ContentNegotiation$lambda$slambda($registrations, $ignoredTypes, $this_createClientPlugin, resultContinuation);
    var l = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
      return i.rd0($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
    };
    l.$arity = 4;
    return l;
  }
  function ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
    this.bd1_1 = $ignoredTypes;
    this.cd1_1 = $registrations;
    this.dd1_1 = $this_createClientPlugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$lambda$slambda_1).hcg = function ($this$transformResponseBody, response, body, info, $completion) {
    var tmp = this.icg($this$transformResponseBody, response, body, info, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(ContentNegotiation$lambda$slambda_1).jcg = function (p1, p2, p3, p4, $completion) {
    var tmp = p1 instanceof TransformResponseBodyContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpResponse ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel) : false) ? p3 : THROW_CCE();
    return this.hcg(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo ? p4 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$lambda$slambda_1).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = contentType(this.fd1_1);
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.id1_1 = tmp_1;
            this.jd1_1 = suitableCharset(get_request(this.fd1_1).w5g());
            this.g9_1 = 1;
            suspendResult = invoke$convertResponse(this.bd1_1, this.cd1_1, this.dd1_1, get_request(this.fd1_1).zby(), this.hd1_1, this.gd1_1, this.id1_1, this.jd1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 2) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$lambda$slambda_1).icg = function ($this$transformResponseBody, response, body, info, completion) {
    var i = new ContentNegotiation$lambda$slambda_1(this.bd1_1, this.cd1_1, this.dd1_1, completion);
    i.ed1_1 = $this$transformResponseBody;
    i.fd1_1 = response;
    i.gd1_1 = body;
    i.hd1_1 = info;
    return i;
  };
  function ContentNegotiation$lambda$slambda_2($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
    var i = new ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation);
    var l = function ($this$transformResponseBody, response, body, info, $completion) {
      return i.hcg($this$transformResponseBody, response, body, info, $completion);
    };
    l.$arity = 4;
    return l;
  }
  function ContentNegotiation$lambda$convertRequest$lambda(it) {
    _init_properties_ContentNegotiation_kt__o183go();
    return toString(it.jcy_1);
  }
  function $invoke$convertRequestCOROUTINE$0(registrations, ignoredTypes, $this_createClientPlugin, request, body, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zcy_1 = registrations;
    this.acz_1 = ignoredTypes;
    this.bcz_1 = $this_createClientPlugin;
    this.ccz_1 = request;
    this.dcz_1 = body;
  }
  protoOf($invoke$convertRequestCOROUTINE$0).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 7;
            var tmp0_iterator = this.zcy_1.g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              l$ret$1: do {
                get_LOGGER().s5a('Adding Accept=' + element.kcy_1.j5c_1 + ' header for ' + this.ccz_1.nbw_1.toString());
                if (this.ccz_1.pbw_1.x56(HttpHeaders_getInstance().t5c_1, element.kcy_1.toString())) {
                  break l$ret$1;
                }
                accept(this.ccz_1, element.kcy_1);
              }
               while (false);
            }

            var tmp_0;
            var tmp_1 = this.dcz_1;
            if (tmp_1 instanceof OutgoingContent) {
              tmp_0 = true;
            } else {
              var tmp$ret$2;
              l$ret$3: do {
                var this_0 = this.acz_1;
                var tmp_2;
                if (isInterface(this_0, Collection)) {
                  tmp_2 = this_0.k();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
                var tmp0_iterator_0 = this_0.g();
                while (tmp0_iterator_0.h()) {
                  var element_0 = tmp0_iterator_0.i();
                  if (element_0.db(this.dcz_1)) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                tmp$ret$2 = false;
              }
               while (false);
              tmp_0 = tmp$ret$2;
            }

            if (tmp_0) {
              get_LOGGER().s5a('Body type ' + toString(getKClassFromExpression(this.dcz_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.ccz_1.nbw_1.toString() + '.'));
              return null;
            }

            var tmp_3 = this;
            var tmp0_elvis_lhs = contentType_0(this.ccz_1);
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              this.bcz_1;
              get_LOGGER().s5a("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.ccz_1.nbw_1.toString() + '.');
              return null;
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            tmp_3.ecz_1 = tmp_4;
            var tmp_5 = this.dcz_1;
            if (tmp_5 instanceof Unit) {
              get_LOGGER().s5a('Sending empty body for ' + this.ccz_1.nbw_1.toString());
              this.ccz_1.pbw_1.c57(HttpHeaders_getInstance().l5d_1);
              return EmptyContent_getInstance();
            }

            var tmp_6 = this;
            var this_1 = this.zcy_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator_1 = this_1.g();
            while (tmp0_iterator_1.h()) {
              var element_1 = tmp0_iterator_1.i();
              if (element_1.lcy_1.ncy(this.ecz_1)) {
                destination.e(element_1);
              }
            }

            var tmp_7;
            if (!destination.k()) {
              tmp_7 = destination;
            } else {
              tmp_7 = null;
            }

            var tmp1_elvis_lhs = tmp_7;
            var tmp_8;
            if (tmp1_elvis_lhs == null) {
              this.bcz_1;
              get_LOGGER().s5a('None of the registered converters match request Content-Type=' + this.ecz_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.ccz_1.nbw_1.toString() + '.'));
              return null;
            } else {
              tmp_8 = tmp1_elvis_lhs;
            }

            tmp_6.fcz_1 = tmp_8;
            if (this.ccz_1.pcm() == null) {
              get_LOGGER().s5a('Request has unknown body type. Skipping ContentNegotiation for ' + this.ccz_1.nbw_1.toString() + '.');
              return null;
            }

            this.ccz_1.pbw_1.c57(HttpHeaders_getInstance().l5d_1);
            this.g9_1 = 1;
            continue $sm;
          case 1:
            var tmp_9 = this;
            tmp_9.hcz_1 = this.fcz_1;
            this.icz_1 = this.hcz_1.g();
            this.g9_1 = 2;
            continue $sm;
          case 2:
            if (!this.icz_1.h()) {
              this.g9_1 = 5;
              continue $sm;
            }

            this.jcz_1 = this.icz_1.i();
            var tmp_10 = this;
            tmp_10.kcz_1 = this.jcz_1;
            this.g9_1 = 3;
            var tmp0_elvis_lhs_0 = charset(this.ecz_1);
            var tmp_11 = tmp0_elvis_lhs_0 == null ? Charsets_getInstance().u53_1 : tmp0_elvis_lhs_0;
            var tmp_12 = ensureNotNull(this.ccz_1.pcm());
            var this_2 = this.dcz_1;
            var tmp_13;
            if (!equals(this_2, NullBody_instance)) {
              tmp_13 = this_2;
            } else {
              tmp_13 = null;
            }

            suspendResult = this.kcz_1.jcy_1.kd1(this.ecz_1, tmp_11, tmp_12, tmp_13, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              get_LOGGER().s5a('Converted request body using ' + toString(this.kcz_1.jcy_1) + ' for ' + this.ccz_1.nbw_1.toString());
            }

            var result_0 = result;
            if (!(result_0 == null)) {
              this.gcz_1 = result_0;
              this.g9_1 = 6;
              continue $sm;
            } else {
              this.g9_1 = 4;
              continue $sm;
            }

          case 4:
            this.g9_1 = 2;
            continue $sm;
          case 5:
            this.gcz_1 = null;
            if (false) {
              this.g9_1 = 1;
              continue $sm;
            }

            this.g9_1 = 6;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = this.gcz_1;
            var tmp_14;
            if (tmp2_elvis_lhs == null) {
              var tmp_15 = "Can't convert " + toString(this.dcz_1) + ' with contentType ' + this.ecz_1.toString() + ' using converters ';
              throw new ContentConverterException(tmp_15 + joinToString(this.fcz_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$lambda$convertRequest$lambda));
            } else {
              tmp_14 = tmp2_elvis_lhs;
            }

            var serializedContent = tmp_14;
            return serializedContent;
          case 7:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 7) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $invoke$convertResponseCOROUTINE$1(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tcz_1 = ignoredTypes;
    this.ucz_1 = registrations;
    this.vcz_1 = $this_createClientPlugin;
    this.wcz_1 = requestUrl;
    this.xcz_1 = info;
    this.ycz_1 = body;
    this.zcz_1 = responseContentType;
    this.ad0_1 = charset;
  }
  protoOf($invoke$convertResponseCOROUTINE$1).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 2;
            var tmp_0 = this.ycz_1;
            if (!isInterface(tmp_0, ByteReadChannel)) {
              get_LOGGER().s5a('Response body is already transformed. Skipping ContentNegotiation for ' + this.wcz_1.toString() + '.');
              return null;
            }

            if (this.tcz_1.r(this.xcz_1.o5a_1)) {
              get_LOGGER().s5a('Response body type ' + toString(this.xcz_1.o5a_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.wcz_1.toString() + '.'));
              return null;
            }

            var tmp_1 = this;
            var this_0 = this.ucz_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = this_0.g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              if (element.lcy_1.ncy(this.zcz_1)) {
                destination.e(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var tmp0_iterator_0 = destination.g();
            while (tmp0_iterator_0.h()) {
              var item = tmp0_iterator_0.i();
              destination_0.e(item.jcy_1);
            }

            var tmp_2;
            if (!destination_0.k()) {
              tmp_2 = destination_0;
            } else {
              tmp_2 = null;
            }

            var tmp0_elvis_lhs = tmp_2;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              this.vcz_1;
              get_LOGGER().s5a('None of the registered converters match response with Content-Type=' + this.zcz_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.wcz_1.toString() + '.'));
              return null;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }

            tmp_1.bd0_1 = tmp_3;
            this.g9_1 = 1;
            suspendResult = deserialize(this.bd0_1, this.ycz_1, this.xcz_1, this.ad0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!isInterface(result, ByteReadChannel)) {
              get_LOGGER().s5a('Response body was converted to ' + toString(getKClassFromExpression(result)) + ' for ' + this.wcz_1.toString() + '.');
            }

            return result;
          case 2:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 2) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_ContentNegotiation_kt_1ayduy;
  function _init_properties_ContentNegotiation_kt__o183go() {
    if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
      properties_initialized_ContentNegotiation_kt_1ayduy = true;
      LOGGER = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
      DefaultCommonIgnoredTypes = setOf([PrimitiveClasses_getInstance().mc(), PrimitiveClasses_getInstance().ic(), getKClass(HttpStatusCode), getKClass(ByteReadChannel), getKClass(OutgoingContent)]);
      var tmp = ContentNegotiationConfig$_init_$ref_1ne3ob();
      ContentNegotiation = createClientPlugin('ContentNegotiation', tmp, ContentNegotiation$lambda);
    }
  }
  function JsonContentTypeMatcher() {
  }
  protoOf(JsonContentTypeMatcher).ncy = function (contentType) {
    if (contentType.n5c(Application_getInstance().f5b_1)) {
      return true;
    }
    var value = contentType.m5c().toString();
    return startsWith(value, 'application/') && endsWith(value, '+json');
  };
  var JsonContentTypeMatcher_instance;
  function JsonContentTypeMatcher_getInstance() {
    return JsonContentTypeMatcher_instance;
  }
  function get_DefaultIgnoredTypes() {
    _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
    return DefaultIgnoredTypes;
  }
  var DefaultIgnoredTypes;
  var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
  function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
    if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
      properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
    }
  }
  //region block: post-declaration
  protoOf(ContentNegotiationConfig).kbs = register$default;
  //endregion
  //region block: init
  JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = get_ContentNegotiation;
  //endregion
  return _;
}));
